var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isMore
        ? _c("div", { staticClass: "index-box index-5" }, [
            _c("div", { staticClass: "index-title" }, [
              _vm._v("\n      越来越多的企业组织都在使用领筑云\n    ")
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hidePartner
        ? _c("div", { staticClass: "index-box index-6" }, [
            _c("div", { staticClass: "index-title" }, [
              _vm._v("\n      90,000+企业的信赖之选\n    ")
            ]),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "index-7" }, [
        _c("div", { staticClass: "index-7-title" }, [
          _vm._v("领筑云-让工程更省心")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-center" },
          [
            _c("svg-icon", { attrs: { name: "icon-phone" } }),
            _vm._v(" "),
            _c("span", [_vm._v("4000-996-660")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: {
                  padding: "11px 20px",
                  "border-radius": "50px",
                  "font-size": "24px",
                  width: "196px"
                },
                attrs: { round: "", type: "primary", plain: "" },
                on: { click: _vm.initDialog }
              },
              [_vm._v("申请使用")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "view-footer" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _vm._l(_vm.list, function(item) {
                return _c(
                  "div",
                  { key: item.title, staticClass: "view-footer-column" },
                  [
                    _c("div", { staticClass: "view-footer-title" }, [
                      _vm._v(
                        "\n            " + _vm._s(item.title) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(item.children, function(cItem) {
                      return _c(
                        "div",
                        {
                          key: cItem.title,
                          staticClass: "view-footer-item view-footer-item-link",
                          on: {
                            click: function($event) {
                              return _vm.openUrl(cItem.url)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(cItem.title) +
                              "\n          "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("img", {
                staticClass: "view-footer-qrcode",
                attrs: { src: require("@/assets/imgs/qrcode.png"), alt: "" }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "view-footer-copyright" },
            [
              _vm._v(
                "\n        © Copyright 2012-2022 深圳智慧建设科技有限公司\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://beian.miit.gov.cn/",
                    target: "_blank"
                  }
                },
                [_vm._v("粤ICP备19073496号")]
              ),
              _vm._v(" "),
              _c("svg-icon"),
              _vm._v(" 粤公网安备\n        44030502004117号\n      ")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("apply-for-use", { ref: "applyForUse" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: require("@/assets/imgs/case-6.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: require("@/assets/imgs/partner.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "view-footer-column flex-fill" }, [
      _c("div", { staticClass: "view-footer-title" }, [
        _vm._v("\n            联系我们\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "view-footer-item" }, [
        _vm._v("\n            全国统一服务热线：4000-996-660\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "view-footer-item" }, [
        _vm._v("\n            深圳领筑科技有限公司\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "view-footer-item" }, [
        _vm._v(
          "\n            公司地址：深圳市南山区艺园路202号马家龙文体中心B栋8楼\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-287eeaa0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-287eeaa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/viewFooter.vue
// module id = null
// module chunks = 